'use client';

import { useEffect } from 'react';

export default function ChangeBodyBackgroundColor({ color }: { color: string }) {
  useEffect(() => {
    const previousColor = document.body.style.backgroundColor;

    document.body.style.backgroundColor = color;

    return () => {
      document.body.style.backgroundColor = previousColor;
    };
  }, [color]);

  return null;
}
